import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Control, Errors, actions } from 'react-redux-form';
import { Row, Col, FormGroup, FormControl, ControlLabel, Radio } from 'react-bootstrap';
import RequiredSelect from '../../../../common/form/elements/required-select';
import RequiredMultiSelect from '../../../../common/form/elements/required-multi-select';
import ImageUpload from '../../../../common/form/elements/image-upload';
import RequiredInput from '../../../../common/form/elements/required-input';
import ArrowButton from '../../../../common/button-arrow';
import { saveBrand, updateBrand } from '../../../../../actions/brands';

class EditBrandForm extends Component {
  componentWillUnmount() {
    this.props.dispatch(actions.reset('deep.admin_brand'));
  }

  onSubmit = payload => {
    const { dispatch, brand: { id }} = this.props;

    if (id) {
      dispatch(actions.submitFields('deep.admin_brand', updateBrand(id, payload)));
    } else {
      dispatch(actions.submitFields('deep.admin_brand', saveBrand(payload)));
    }
  }

  render() {
    const { dispatch, brand, isOtherSelected, ...props } = this.props;

    let image;
    let banner;

    if (brand) {
      const { attributes } = brand;
      image = attributes.links ? attributes.links.image : undefined;
      banner = attributes.links ? attributes.links.banner : undefined;
    }

    return (
      <Form
        model="deep.admin_brand"
        onSubmit={this.onSubmit}
        errors={{
          '': {
            bannerTextColourValid: ({ banner_text_colour, banner_text_colour_custom }) => {
              if (banner_text_colour === 'other') {
                if (!/^#[0-9a-f]{6}$/i.test(''+banner_text_colour_custom)) return 'is not a valid hex colour';
              } else {
                if (!banner_text_colour) return 'is required';
              }
            }
          }
        }}
      >
        <Row>
          <Col lg={12}>
            <RequiredInput label="Name"
              placeholder="Name"
              model='.name'
              controlId='name'/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <ImageUpload source={image}
              sizeLimit={1024 * 1024}
              type={['image/png', 'image/jpg', 'image/jpeg']}
              model=".photo"
              required/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <RequiredMultiSelect data={props.categories.map(category => {return {id: category.id, name: category.attributes.name}})}
              value={props.selectedCategories}
              label="Categories"
              labelAttr="name"
              valueAttr="id"
              controlId="brandCategory"
              model='deep.admin_brand.categories'/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <RequiredSelect model=".status"
              values={props.statuses}
              label="Status"
              controlId="brandCategory"/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <ImageUpload
              label="Banner image"
              source={banner}
              sizeLimit={1024 * 1024}
              type={['image/png', 'image/jpg', 'image/jpeg']}
              model=".banner"
              required
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <FormGroup controlId="bannerTextColour">
              <div>
                <ControlLabel>Banner text colour</ControlLabel>
              </div>
              <div>
                {['Red', 'Yellow', 'White', 'Grey'].map(colour => (
                  <Control.radio key={colour} inline model=".banner_text_colour" value={colour} component={Radio}>
                    {colour}
                  </Control.radio>
                ))}
                <Control.radio inline model=".banner_text_colour" value="other" component={Radio}>
                  Other
                </Control.radio>
                {isOtherSelected && (
                  <div className="form-inline">
                    <Control.text model=".banner_text_colour_custom" className="form-control" />
                  </div>
                )}
              </div>
              <Errors
                model="deep.admin_brand"
                show={{ touched: true, focus: false }}
                wrapper="span"
                className="errors"
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <FormGroup controlId="bannerTitle">
              <ControlLabel>Banner title</ControlLabel>
              <Control.text
                model=".banner_title"
                component={FormControl}
              />
              <Errors
                show={{touched: true, focus: false}}
                className="errors"
                model=".banner_title"
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <FormGroup controlId="bannerText">
              <ControlLabel>Banner text</ControlLabel>
              <Control.text
                model=".banner_text"
                component={FormControl}
              />
              <Errors
                show={{touched: true, focus: false}}
                className="errors"
                model=".banner_text"
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <ArrowButton color="grey"
              className="pull-right"
              disabled={!props.formValid}>Save</ArrowButton>
          </Col>
        </Row>
      </Form>
    )
  }
};

const mapStateToProps = (state) => {
  return {
    statuses: state.brands.editorInput.statuses || [],
    categories: state.brands.editorInput.categories || [],
    selectedCategories: state.deep.admin_brand.categories,
    formValid: state.deep.forms.admin_brand.$form.valid,
    isOtherSelected: state.deep.admin_brand.banner_text_colour === 'other'
  };
};

export default connect(mapStateToProps)(EditBrandForm);



// WEBPACK FOOTER //
// ./src/components/admin/products/brands/edit/brand-edit-form.jsx